import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as yup from 'yup';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import moment from 'moment';

interface IAbsenceContext {
    isLoading: boolean
    absence: Absence

    searchUsers: (searchText: string) => void
    saveAbsence: (absence: Absence) => void
}

export interface User {
    value: string
    label: string
}

export let absenceSchema = yup.object().shape({
    absenceId: yup.string().nullable().default(''),
    userName: yup.string().required().default('').label('Utente'),
    typology: yup.string().required().default('').label('Tipologia'),
    otherTypology: yup.string().nullable().default('').label('Altra Tipologia'),
    notes: yup.string().nullable().default('').label('Note'),
    startDate: yup.date().required().default(moment().utc(true).toDate()).label('Data Inizio'),
    endDate: yup.date().required().default(moment().utc(true).toDate()).label('Data Fine'),
    notifyHr: yup.boolean().default(false).label('Notifica HR')
});

type Absence = yup.InferType<typeof absenceSchema>;

export let absenceContext = React.createContext({} as IAbsenceContext);

let { Provider } = absenceContext;

let AbsenceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let history = useHistory();
    let { enqueueSnackbar } = useSnackbar();

    let isNew = location.pathname.includes("/addnew");

    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [absence, setAbsence] = useState<Absence>(absenceSchema.getDefault());


    useEffect(() => {
        if (isNew === false)
            getAbsence();

    }, [id, isNew])

    let getAbsence = async () => {
        try {
            let res = await axios.get('/api/Absence/GetAbsence', { params: { absenceId: id } });

            let { item } = res.data;
            setAbsence({
                ...item,
                adminArea: item.adminArea ?? [],
                groups: item.groups ?? [],
                enabledLocales: item.enabledLocales ?? [],
            });
            setLoading(false);

        } catch (err) { }
        finally {
        }
    }

    let saveAbsence = async (value: Absence) => {
        try {
            let request = {
                ...value,
                startDate: moment(value.startDate).startOf('day').utc(true),
                endDate: moment(value.endDate).startOf('day').utc(true)
            }
            await axios.post('/api/Absence/SaveAbsence', request);
            enqueueSnackbar("Absence saved", { variant: "success" });
            history.push(`/absences`);

        } catch (err) {
        }
    }


    let searchUsers = async (searchText: string) => {
        if (!searchText)
            return;

        try {

            let request = {
                searchText: searchText
            };

            const res = await axios.get('/api/User/UsersQuickSearch', { params: request });
            return res.data.items;
        } catch { }
    }

    return (
        <Provider
            value={{
                isLoading,
                absence,

                searchUsers,
                saveAbsence
            }}
        >
            {children}
        </Provider>
    )
}

export default AbsenceProvider;